import type { UIStrings } from './en';

export const ru: UIStrings = {
  'site.title': 'DopeJs — открытые инструменты для разработки с агентами',
  'site.description':
    'DopeJs создаёт открытые инструменты для разработки в эпоху ИИ: среды выполнения агентов, терминальные агенты для кода, инструменты окружения для CLI и движки рендеринга Canvas.',

  'nav.projects': 'Проекты',
  'nav.about': 'О проекте',
  'nav.github': 'GitHub',
  'nav.skip': 'Перейти к содержимому',
  'nav.theme': 'Тема',
  'nav.language': 'Язык',

  'hero.eyebrow': 'открытый код · разработка на виду',
  'hero.title': 'Инструменты для разработки с ИИ.',
  'hero.body':
    'DopeJs — небольшая группа открытых проектов вокруг одного вопроса: как выглядит софт, которым вы пользуетесь каждый день, когда агенты становятся частью процесса? Среды выполнения агентов, терминальные агенты для кода, инструменты окружения CLI, движки рендеринга Canvas — всё разрабатывается публично.',
  'hero.cta.projects': 'Смотреть проекты',
  'hero.cta.github': 'Открыть на GitHub',
  'hero.count': 'проектов',

  'projects.title': 'Проекты',
  'projects.repo': 'Репозиторий',
  'projects.homepage': 'Сайт',
  'projects.install': 'Установка',
  'projects.copy': 'Копировать',
  'projects.copied': 'Скопировано',
  'projects.details': 'Подробнее',

  'status.stable': 'Выпущено',
  'status.active': 'Активная разработка',
  'status.early': 'Ранняя стадия — не для продакшена',
  'status.design': 'Стадия проектирования',

  'project.back': 'Все проекты',
  'project.overview': 'Обзор',
  'project.highlights': 'Что он делает',
  'project.getStarted': 'Начало работы',
  'project.requirements': 'Требования',
  'project.facts': 'Кратко',
  'project.facts.status': 'Статус',
  'project.facts.languages': 'Языки',
  'project.facts.license': 'Лицензия',
  'project.facts.noLicense': 'Пока нет',
  'project.links': 'Ссылки',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': 'Предыдущий',
  'project.next': 'Следующий',

  'about.title': 'О DopeJs',
  'about.body':
    'Всё здесь разрабатывается открыто, на GitHub. Issues и pull requests приветствуются в любом репозитории — как и честные сообщения о том, что что-то пока не работает. Некоторые проекты намеренно находятся в предрелизном состоянии; там, где это так, проект прямо об этом говорит.',
  'about.cta': 'Подписаться на организацию в GitHub',

  'footer.built': 'Сделано на React и Vite. Исходный код на GitHub.',
  'footer.rights': 'DopeJs',
  'footer.translations': 'Переводы сделаны машинно — исправления приветствуются.',
};
